class Payment {
  constructor() {
    this.init();
  }

  init() {
    this.payment_id = undefined;
    this.payment_type = undefined;
    this.spots = undefined;
    this.seat_id = undefined;
    this.contract_id = undefined;
    this.total = undefined;
    this.coupon_code = undefined;
    this.transfers = [];
    this.payment_date = undefined;
    this.pending = undefined;
    this.receipt = undefined;
    this.data = undefined;
  }

  copy() {
    const cp = new Payment();

    cp.payment_id = this.payment_id;
    cp.payment_type = this.payment_type;
    cp.seat_id = this.seat_id;
    cp.contract_id = this.contract_id;
    cp.total = this.total;
    cp.coupon_code = this.coupon_code;
    cp.payment_date = this.payment_date;
    cp.pending = this.pending;
    cp.receipt = this.receipt;
    cp.spots = this.spots ? [...this.spots] : undefined;
    cp.data = this.data ? Object.assign({}, this.data) : undefined;    
    cp.transfers = this.transfers ? [...this.transfers] : [];
    cp.transfers.forEach((t) => {
      if (t.payout_date) {
        t.payout_date = new Date(t.payout_date);
      }
    });

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.payment_id = obj.payment_id ? obj.payment_id.toString() : undefined;
      this.payment_type = obj.payment_type ? obj.payment_type : undefined;
      this.seat_id = obj.seat_id ? obj.seat_id.toString() : undefined;
      this.contract_id = obj.contract_id ? obj.contract_id.toString() : undefined;
      this.total = obj.total;
      this.coupon_code = obj.coupon_code;
      this.payment_date = obj.payment_date ? new Date(obj.payment_date) : undefined;
      this.pending = (obj.pending !== undefined) && (obj.pending !== null) ? obj.pending : undefined;
      this.receipt = obj.receipt ? obj.receipt : undefined;
      this.spots = obj.spots ? [...obj.spots] : undefined;
      this.data = obj.data ? Object.assign({}, obj.data) : undefined;
      this.transfers = obj.transfers ? [...obj.transfers] : [];
      this.transfers.forEach((t) => {
        if (t.payout_date) {
          t.payout_date = new Date(t.payout_date);
        }
      });
    }
  }

  toString() {
    let result = this.payment_id ? this.payment_id : '';
    return result;
  }

  getId() {
    return this.payment_id;
  }

  setId(payment_id) {
    this.payment_id = payment_id ? payment_id.toString() : undefined;
  }
  
  getPaymentType() {
    return this.payment_type;
  }

  setPaymentType(payment_type) {
    this.payment_type = payment_type;
  }
  
  getSpots() {
    return this.spots;
  }

  setSpots(spots) {
    this.spots = spots ? [...spots] : undefined;
  }

  getSeatId() {
    return this.seat_id;
  }

  setSeatId(seat_id) {
    this.seat_id = seat_id ? seat_id.toString() : undefined;
  }

  getContractId() {
    return this.contract_id;
  }

  setContractId(contract_id) {
    this.contract_id = contract_id ? contract_id.toString() : undefined;
  }

  getTotal() {
    return this.total;
  }

  setTotal(total) {
    this.total = total;
  }

  getCouponCode() {
    return this.coupon_code;
  }

  setCouponCode(coupon_code) {
    this.coupon_code = coupon_code;
  }
  
  getTransfers() {
    return this.transfers;
  }

  setTransfers(transfers) {
    this.transfers = transfers ? [...transfers] : [];
    this.transfers.forEach((t) => {
      if (t.payout_date) {
        t.payout_date = new Date(t.payout_date);
      }
    });
  }

  getPaymentDate() {
    return this.payment_date;
  }

  setPaymentDate(payment_date) {
    this.payment_date = payment_date ? new Date(payment_date) : undefined;
  }

  getPending() {
    return this.pending;
  }

  setPending(pending) {
    this.pending = pending;
  }
  
  getReceipt() {
    return this.receipt;
  }

  setReceipt(receipt) {
    this.receipt = receipt;
  }

  getData() {
    return this.data;
  }

  setData(data) {
    this.data = data ? Object.assign({}, data) : undefined;
  }
}

module.exports = Payment;
